import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import CompanyLogo from "../assets/images/new_logo.jpeg";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };
  const location = useLocation();
  // console.log(location);
  // const [isScrolled, setIsScrolled] = useState(false);


  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY >= 50) {
  //       setIsScrolled(true);
  //     } else {
  //       setIsScrolled(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3 },
  };

  return (
    <motion.section {...fadeIn}>
      <div className=" smallHeader">
        <div className=" d-flex align-items-center justify-content-center">
          <RouterLink to="/">
          <img
            className= "main-logo logo logo-media"
               
           
            src={CompanyLogo}
            alt="main logo"
            onClick={handleClick}
          />
          </RouterLink>
        </div>
        <div
          className= "d-flex align-items-center justify-content-center gap-3 media-font-scroll "
            
        >
          {location.pathname === "/" && (
            <ScrollLink style={{ cursor: "pointer" }} to="accordian">
              FAQ
            </ScrollLink>
          )}

          <h1
            className= "media-font-scroll mb-0 text-logo"
               
          >
            <RouterLink
              to="/"
              style={{
                cursor: "pointer",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              EU AI Act
            </RouterLink>
          </h1>
        </div>
      </div>
    </motion.section>
  );
};

export default Header;
